import Image from "next/image";
import Link from "next/link";
import type { ReactNode } from "react";

export const TrainingHeader = ({
  title,
  action,
}: {
  title?: string;
  action?: ReactNode;
}) => {
  return (
    <div className="pb-2.5 p-0 md:p-5 w-full">
      <div className="md:bg-white md:border border-d-border flex flex-col items-start p-5 md:rounded-3xl md:shadow-sm">
        <div className="flex gap-8 items-center w-full">
          <div className="flex flex-1 gap-6 items-center">
            <div className="flex items-center shrink-0">
              <Link href="/">
                <Image
                  src="/logo.svg"
                  alt="Yolk"
                  width={116}
                  height={40}
                  className="h-10 w-[115.702px]"
                />
              </Link>
            </div>
            <div className="flex gap-6 items-center shrink-0">
              <p className="hidden md:block font-semibold leading-7 shrink-0 text-d-black text-[22px]">
                {title}
              </p>
            </div>
          </div>
          {action}
        </div>
      </div>
    </div>
  );
};
